import { Controller } from "@hotwired/stimulus"

// Swaps in a replacement when an image fails to load.
//
// Legacy gallery thumbnails are unreliable: the bucket has full images under
// "gallery/Wintercup 2009/" but their thumbnails under "gallery_thumbs/
// Wintercup_2009/", and some have no thumbnail at all. Rather than probing S3
// on every render, fall back to the full-size picture when the thumb 404s.
//
//   <img data-controller="image-fallback"
//        data-image-fallback-src-value="<%= image.file_url %>"
//        data-action="error->image-fallback#error">
export default class extends Controller {
    static values = { src: String }

    error() {
        if (!this.srcValue || this.element.dataset.fallbackApplied) return

        this.element.dataset.fallbackApplied = "true" // never loop
        this.element.src = this.srcValue
    }
}
